import types from './types';

const convertTagsToObject = (tags, selectedTag) => tags.reduce((tagsByKey, tag) => {
    if (!tagsByKey[tag]) {
        tagsByKey[tag] = {};
    }

    if (!selectedTag || selectedTag === tag) {
        tagsByKey[tag].loading = false;
    }

    tagsByKey[tag].subscribed = true;

    return tagsByKey;
}, {});

const setTagLoading = (tagsByKey, selectedTag) => {
    if (!tagsByKey[selectedTag]) {
        tagsByKey[selectedTag] = {};
    }

    tagsByKey[selectedTag].loading = true;

    return tagsByKey;
};

const handleTagsSuccess = (state, { payload: { tags, selectedTag } }) => ({
    ...state,
    isLoading: false,
    campaignNotificationTags: convertTagsToObject(tags, selectedTag)
});

const handleTagsError = (state, { payload }) => ({
    ...state,
    isLoading: false,
    campaignNotificationTags: setTagLoading({ ...state.campaignNotificationTags }, payload)
});

const handleTagsRequest = (state) => ({
    ...state,
    isLoading: true
});
const handleTagChangeRequest = (state, { payload }) => ({
    ...state,
    isLoading: true,
    campaignNotificationTags: setTagLoading({ ...state.campaignNotificationTags }, payload)
});

export const fetchNotificaitonTags = {
    [types.FETCH_NOTIFICATION_TAGS.REQUEST]: handleTagsRequest,
    [types.FETCH_NOTIFICATION_TAGS.SUCCESS]: handleTagsSuccess,
    [types.FETCH_NOTIFICATION_TAGS.ERROR]: handleTagsError
};

export const addNotificationTag = {
    [types.ADD_NOTIFICATION_TAG.REQUEST]: handleTagChangeRequest,
    [types.ADD_NOTIFICATION_TAG.SUCCESS]: handleTagsSuccess,
    [types.ADD_NOTIFICATION_TAG.ERROR]: handleTagsError
};

export const removeNotificaitonTag = {
    [types.REMOVE_NOTIFICATION_TAG.REQUEST]: handleTagChangeRequest,
    [types.REMOVE_NOTIFICATION_TAG.SUCCESS]: handleTagsSuccess,
    [types.REMOVE_NOTIFICATION_TAG.ERROR]: handleTagsError
};
